import React from "react";
import arrowRightBlue from "../../assets/images/icons/arrow_right_blue.svg";

const PAGE_SIZES = [12, 20, 40, 80, 100];

function OfferPagination({ currentPage, totalPages, pageSize, onPageChange, onPageSizeChange }) {

    const getPageNumbers = () => {
        if (totalPages <= 7) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }

        const pages = [1];

        if (currentPage > 3) pages.push('...');

        const rangeStart = Math.max(2, currentPage - 1);
        const rangeEnd = Math.min(totalPages - 1, currentPage + 1);
        for (let i = rangeStart; i <= rangeEnd; i++) {
            pages.push(i);
        }

        if (currentPage < totalPages - 2) pages.push('...');

        pages.push(totalPages);

        return pages;
    };

    return (
        <div className="offer-pagination-row">
            <div className="offer-pagination-sizes">
                <span className="offer-pagination-sizes-label">ofert na stronie</span>
                <div className="offer-pagination-sizes-items">
                    {PAGE_SIZES.map(size => (
                        <button
                            key={size}
                            className={"offer-pagination-size-btn" + (pageSize === size ? " active" : "")}
                            onClick={() => onPageSizeChange(size)}
                        >
                            {size}
                        </button>
                    ))}
                </div>
            </div>

            {totalPages > 1 && (
                <div className="offer-pagination-pages">
                    <button
                        className="offer-pagination-arrow"
                        onClick={() => onPageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        aria-label="Poprzednia strona"
                    >
                        <img src={arrowRightBlue} alt="" className="offer-pagination-arrow-icon offer-pagination-arrow-prev" />
                    </button>

                    {getPageNumbers().map((page, idx) =>
                        page === '...' ? (
                            <span key={`dots-${idx}`} className="offer-pagination-page-btn offer-pagination-dots">...</span>
                        ) : (
                            <button
                                key={page}
                                className={"offer-pagination-page-btn" + (currentPage === page ? " active" : "")}
                                onClick={() => onPageChange(page)}
                            >
                                {page}
                            </button>
                        )
                    )}

                    <button
                        className="offer-pagination-arrow"
                        onClick={() => onPageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        aria-label="Następna strona"
                    >
                        <img src={arrowRightBlue} alt="" className="offer-pagination-arrow-icon" />
                    </button>
                </div>
            )}
        </div>
    );
}

export default OfferPagination;
